import RightArrow from "../../assets/Images/rightArrow.png";

const InstituteCard = ({ item }) => {
  const handleClick = () => {
    window.open(item.App_Link, "_blank");
  };

  return (
    <div
      onClick={handleClick}
      className="flex justify-between items-center bg-colorWhite rounded px-4 py-4 ml-4"
    >
      <div>
        <img
          width={40}
          src={item.Logo}
          alt="institute-logo"
          referrerPolicy="no-referrer"
        />
      </div>
      <div>
        <div className="text-colorCardTitle">{item.App_Name || item.name}</div>
        {item.City || item.State ? (
          <div className="text-colorCardBody text-sm">
            {item.City}, {item.State}
          </div>
        ) : (
          ""
        )}

        <div className="text-colorCardBody text-sm">
          {Number(item.Download) > 500 ? (
            <>
              {Number(item.Download) > 1000 &&
                `${Math.floor(Number(item.Download) / 1000)}k downloads`}
            </>
          ) : (
            ""
          )}
          {item.subscribers ? item.subscribers : ""}
        </div>
      </div>
      <div>
        <img width={10} src={RightArrow} alt="right-arrow" />
      </div>
    </div>
  );
};

export default InstituteCard;
